import { DashboardMarket, DashboardMarketAsset } from "@silo/types";
import { ReactNode } from "react";
import { cn } from "../../../utils/class-names";
import { LendingLinkContext } from "../lending-link-context";

interface ActionContainerProps {
  className?: string;
  children?: ReactNode;
  market: DashboardMarket;
  asset: DashboardMarketAsset | undefined;
}

export function ActionContainer({
  className,
  children,
  market,
  asset,
}: ActionContainerProps): JSX.Element {
  const { marketAddress } = market;
  const tokenAddress = asset?.tokenAddress;

  return (
    <div className={cn("flex flex-col gap-5", className)}>
      <div className="flex gap-2.5 lg:gap-8">
        <LendingLinkContext.Provider value={{ marketAddress, tokenAddress }}>
          {children}
        </LendingLinkContext.Provider>
      </div>
    </div>
  );
}
